import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useHistory } from "react-router-dom";

const CustomerDropdown = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const history = useHistory();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRegisterCustomer = () => {
    handleClose();
    history.push("/register-customer");
  };

  const handleCustomerOverview = () => {
    handleClose();
    history.push("/customer-overview");
  };

  return (
    <div>
      <Button
        id="customer-button"
        aria-controls={open ? "customer-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        color="inherit"
        endIcon={<ArrowDropDownIcon />}
      >
        Customer
      </Button>
      <Menu
        id="customer-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "customer-button",
        }}
      >
        <MenuItem onClick={handleCustomerOverview}>Customer Overview</MenuItem>
        <MenuItem onClick={handleRegisterCustomer}>Register Customer</MenuItem>
      </Menu>
    </div>
  );
};

export default CustomerDropdown;
